// extracted by mini-css-extract-plugin
module.exports = {"vidazoo-logo":"cdJrU","dark":"tyn+m","body":"d0euM","icon":"JTfIC"};